import { Cloudinary, CloudinaryImage } from '@cloudinary/url-gen';
import { useMemo } from 'react';

function useCloudinaryImage(url?: string | null): CloudinaryImage {
  return useMemo(() => {
    const cld = new Cloudinary({
      cloud: {
        cloudName: process.env.GATSBY_CLOUDINARY_CLOUD_NAME,
      },
    });

    const imgFilename = url?.substring(url.lastIndexOf('/') + 1);
    const image = cld.image(`/${process.env.GATSBY_CLOUDINARY_FOLDER}/${imgFilename}`);
    image.format('auto');
    return image;
  }, []);
}

export default useCloudinaryImage;
